import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Box, Grid } from "@chakra-ui/react";

import {
  getSingleProduct,
  getOrderById,
} from "../../Redux/ProductController/action";

import axios from "axios";
import { BASE_URL_USER } from "../../Redux/App/action";
import OrderSummary from "./OrderSummary";
import Delivery from "./Delivery";
import PaymentCard from "./PaymentCard";
import PaymentMethod from "./PaymentMethod";

const PlaceOrder = () => {
  const dispatch = useDispatch();
  const [accordionIndex, setAccordionIndex] = useState(0);
  const [isAddressSelect, setIsAddressSelect] = useState(false);
  const [isPaymentSelect, setIsPaymentSelect] = useState(false);
  const [reload, setReload] = useState(false);
  const [finalPriceData, setFinalPriceData] = useState(null);
  const [originalPrice, setOriginalPrice] = useState(0);
  const [paymentType, setPaymentType] = useState("CART");

  const [selectedAddress, setSelectedAddress] = useState(null);

  const { cartItems, orderDataById } = useSelector(
    (store) => store.prodReducer
  );

  // eslint-disable-next-line no-unused-vars
  const [profileData, setProfileData] = useState([]);
  const [address, setAddress] = useState([]);
  const [addressLoading, setIsAddressLoading] = useState(true);
  const [cartData, setCartData] = useState([]);
  const myState = useSelector((state) => state.ProductCart);
  const accessToken = localStorage.getItem("token");
  const OrderId = localStorage.getItem("orderId");

  useEffect(() => {
    if (cartData.length > 0) {
      let total = 0;
      cartData.forEach((item) => {
        total =
          total + item.quantity * item.productDetail.priceDetails.price;
      });
      setOriginalPrice(total);
    }
  }, [cartData]);

  useEffect(() => {
    const productDetailsWithQuantity = myState.products.map((item) => ({
      productDetail: item.productDetail,
      quantity: item.quantity,
    }));
    setCartData(productDetailsWithQuantity);
  }, [myState.products]);
  useEffect(() => {
    dispatch(getOrderById(OrderId));
  }, [dispatch, OrderId]);

  const [sId, setSId] = useState(0);

  useEffect(() => {
    if (cartItems && cartItems.length > 0) {
      const productIds = cartItems.map((item) => item.productDetail.productId);
      productIds.forEach((productId) => {
        dispatch(getSingleProduct(productId));
      });
    }
  }, [cartItems, dispatch]);

  const getProfileData = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL_USER}/api/v1/user/get-profile`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (response.status === 200) {
        setProfileData(response.data.payload);
        setSId(response.data.payload.userImg);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getProfileData();
    getAddressData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sId, reload]);

  const getAddressData = async () => {
    setIsAddressLoading(true);
    try {
      const response = await axios.get(
        `${BASE_URL_USER}/api/v1/user/get-address`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (response.status === 200) {
        setAddress(response.data.payload);
        setIsAddressLoading(false);
      }
    } catch (error) {
      setIsAddressLoading(false);
    }
  };

  return (
    <Box mt={"10"}>
      <Grid
        templateColumns={{ base: "1fr", md: "70% 30%" }}
        gap={3}
        width="100%"
        className="p-2 md:p-8"
      >
        <Box>
          {/* Delivery Section */}
          <div>
            <div className="text-left">1. Select a delivery address</div>
            <div className="md:p-4">
              <Delivery
                data={address}
                // orderId={orderDataById.orderId}
                orderId={OrderId}
                reload={reload}
                setReload={setReload}
                selectedAddress={selectedAddress}
                setSelectedAddress={setSelectedAddress}
                setIsAddressSelect={setIsAddressSelect}
                addressLoading={addressLoading}
                profileData={profileData}
              />
            </div>
          </div>

          {/* Payment Section */}
          <div>
            <div className="text-left">2. Choose Payment Method</div>
            <div className="md:p-4">
              <PaymentMethod
                // orderId={orderDataById.orderId}
                orderId={OrderId}
                reload={reload}
                setReload={setReload}
                setFinalPriceData={setFinalPriceData}
                paymentType={paymentType}
                setPaymentType={setPaymentType}
              />
            </div>
          </div>
          {/* Order Summary Section */}
          <div>
            <div className="text-left">3. Order Summary</div>
            <div className="md:p-4">
              <OrderSummary
                data={orderDataById}
                cartData={cartData}
                finalPriceData={finalPriceData}
              />
            </div>
          </div>
        </Box>
        <Box order={{ base: -1, md: "initial" }}>
          <PaymentCard
            // orderId={orderDataById.orderId}
            orderId={OrderId}
            isAddressSelect={isAddressSelect}
            isPaymentSelect={isPaymentSelect}
            setAccordionIndex={setAccordionIndex}
            setIsAddressSelect={setIsAddressSelect}
            setIsPaymentSelect={setIsPaymentSelect}
            accordionIndex={accordionIndex}
            reload={reload}
            setReload={setReload}
            finalPriceData={finalPriceData}
            addressData={address}
            selectedAddress={selectedAddress}
            originalPrice={originalPrice}
            paymentType={paymentType}
          />
        </Box>
      </Grid>
    </Box>
  );
};

export default PlaceOrder;
